import type { FaireProductEntity } from "../../entity_types/product";

export const p_satwcknq88: FaireProductEntity = {
  token: "p_satwcknq88",
  type: "product",
  name: "Boulder Canyon Olive Oil Kettle Chips, 12-Pack, 5 Oz Each",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/413a8bd35fde6b00f3cccb81576381ca676704b0e6c0dbc38b2b3354c4792186.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7cc20b8c0929174639ca37086f896191d800203b5cfe03da99625fdf570fd6a3.jpeg",
    "https://cdn.faire.com/fastly/4d9ed0726417c5b467e6e27ca3b99059525e5e684f2b62a28e41f6935362d4cb.jpeg",
  ],
  priceDollars: 66.58,
  description:
    "Indulge in the savory taste of kettle-cooked potato chips made with care using premium American-grown potatoes. Each chip is thickly sliced and cooked in 100% pure olive oil, offering a rich and aromatic flavor that is both satisfying and unforgettable. Perfect for those with dietary preferences, these chips are vegan, kosher, and free from gluten, trans fat, MSG, and cholesterol.\n\n * Rich, aromatic flavor from olive oil cooking \n * Vegan and kosher-friendly snack \n * Free from gluten, trans fat, MSG, and cholesterol \n * Made in the USA with premium ingredients \n * Convenient 5 oz. bags, sold in a case of 12 \nWhether you're hosting a party or craving a crunchy snack, these kettle chips are the perfect choice for any occasion.",
  tags: [],
  msrpDollars: 115.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:56.541Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
